import fetchData from "../../../utils/fetchData";
import { cifrarAES, decryptAES } from "../../../utils/cryptoUtils";
const urlParametrizacion =
  process.env.REACT_APP_URL_SERVICIOS_PARAMETRIZACION_SERVICIOS;
  const urlCategorias =
    process.env.REACT_APP_URL_CATEGORIAS;
// const urlParametrizacionTest =`http://127.0.0.1:5000`;

export const postCreateCategoria = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/create`,
      "POST",
      {},
      obj
    );
    if (!res?.status) {
      console.error(res?.msg);
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const postCreateSubCategoria = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/createSubCat`,
      "POST",
      {},
      obj
    );
    if (!res?.status) {
      console.error(res?.msg);
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const putEditCategoria = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/update`,
      "PUT",
      {},
      obj
    );
    if (!res?.status) {
      console.error(res?.msg);
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const putEditSubCategoria = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/updateSubCat`,
      "PUT",
      {},
      obj
    );
    if (!res?.status) {
      console.error(res?.msg);
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const fetchCategoriaById = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/getById`,
      "POST",
      {},
      obj
    );
    if (res?.status) {
      return res?.obj;
    } else {
      console.error(res?.msg);
      return { maxPages: 0, results: [] };
    }
  } catch (err) {
    throw err;
  }
};

export const postDeleteCategoria = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/delete`,
      "POST",
      {},
      obj
    );
    if (!res?.status) {
      console.error(res?.msg);
    }
    return res;
  } catch (err) {
    throw err;
  }
};

export const fetchCreatePresignedUrl = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/getPresignedUrlImages`,
      "POST",
      {},
      obj
    );
    if (res?.status) {
      return res
    } else {
      console.error(res);
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const uploadFilePresignedUrl = async (obj, file) => {
  const formData = new FormData();
  Object.entries(obj?.fields).map(([key, value]) => {
    formData.append(key, value);
  });
  formData.append("file", file);
  try {
    const res = await fetch(obj?.url, {
      method: "POST",
      body: formData,
    });
    if (res.ok) {
      return res;
    } else {
      console.error(res);
      return [];
    }
  } catch (err) {
    throw err;
  }
};

export const fetchCategoriasImgs = async (obj) => {
  try {
    const res = await fetchData(
      `${urlParametrizacion}/categorias/getAllImages`,
      "POST",
      {},
      obj,
      {}
    );
    if (res?.status) {
      return res;
    } else {
      console.error(res);
      return [];
    }
  } catch (err) {
    throw err;
  }
};

const buildPostFunctionEncryption = (url) => {
  return async (body) => {
    if (!body) {
      return new Promise((resolve, reject) => {
        resolve("Sin datos body");
      });
    }
    let parseObj = JSON.stringify(body);
    let dataObj = {
      data: cifrarAES(
        `${process.env.REACT_APP_LLAVE_AES_ENCRYPT_CORRESPONSALIA_OTROS}`,
        `${process.env.REACT_APP_IV_AES_ENCRYPT_CORRESPONSALIA_OTROS}`,
        parseObj
      ),
    };
    try {
      const res = await fetchData(
        url,
        "POST",
        {},
        dataObj,
        {},
        {},
        40000
      );
      if (!res?.status) {
        console.error(res?.msg);
      }
      if (res?.obj && Object.keys(res.obj).length > 0) {
        const dataDecrypt = res?.obj?.data;
        const obj = decryptAES(
          `${process.env.REACT_APP_LLAVE_AES_DECRYPT_CORRESPONSALIA_OTROS}`,
          `${process.env.REACT_APP_IV_AES_DECRYPT_CORRESPONSALIA_OTROS}`,
          dataDecrypt
        );
        res.obj = JSON.parse(obj);
      }
      return res;
    } catch (err) {
      throw err;
    }
  };
};

export const fetchCategorias = buildPostFunctionEncryption(`${urlParametrizacion}/categorias/all`);

export const fetchCategoriaConvenios = async (categoria) => {
  try {
    const url = `${urlCategorias}/categorias/convenios?categoria=${encodeURIComponent(categoria)}&app=PDP`;
    const res = await fetchData(url, "GET");
    if (res?.data) {
      return res;
    } else {
      console.error(res?.code, res?.message);
      return null;
    }
  } catch (error) {
    console.error("Error al obtener los convenios:", error);
    throw error;
  }
};
